declare namespace $ {

	export class $shm_hitalama_skills_source extends $shm_textarea_code {
		entry( ): $shm_hitalama_skills_entry
		path( ): string
		sidebar_showed( ): boolean
		saving( next?: boolean ): boolean
		failure( next?: string ): string
	}
	
}

//# sourceMappingURL=source.view.tree.d.ts.map